import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-certificate-badge',
  templateUrl: './certificate-badge.component.html',
  styleUrls: ['./certificate-badge.component.scss']
})
export class CertificateBadgeComponent {

  @Input() isCertified: boolean = false;
  @Input() certifiedText: string = 'Certificado';
  @Input() notCertifiedText: string = 'No certificado';
  @Input() iconOnly: boolean = false;

  constructor() { }

}

